'use client'
import { useState } from 'react'
import { ChevronDown } from 'lucide-react'
import { cn } from '@/lib/utils'

const faqs = [
  {
    question: 'How do I request a song?',
    answer: 'Go to the Songs page, find the song you want, and click the thumbs-up button to vote for it. The more votes a song gets, the higher it moves up the list.'
  },
  {
    question: 'Do I need an account to vote?',
    answer: 'No, you can vote without an account. However, creating an account allows you to rate songs with stars and track your voting history.'
  },
  {
    question: 'How do star ratings work?',
    answer: 'Logged-in users can rate songs from 1 to 5 stars. The average rating is displayed next to each song, and songs are sorted by their average rating.'
  },
  {
    question: 'Can I listen to songs on the platform?',
    answer: 'Yes! If a song has an audio file uploaded, you can play it directly. Some songs also have YouTube links for streaming.'
  },
  {
    question: 'How do I become a DJ on this platform?',
    answer: 'Contact us through the Contact page to learn about DJ partnerships. We provide tools for DJs to manage events and song requests.'
  },
  {
    question: 'Is the platform free?',
    answer: 'Yes, the basic features are completely free for event attendees. DJs and event organizers may have premium features available.'
  }
]

export default function FAQPage() {
  const [openIndex, setOpenIndex] = useState<number | null>(0)

  return (
    <div className="min-h-screen pt-24 pb-12 px-4">
      <div className="container max-w-3xl mx-auto">
        <h1 className="text-4xl md:text-5xl font-black text-white mb-4">FAQ</h1>
        <p className="text-zinc-400 mb-8">Frequently asked questions about DJ Pordesi.</p>

        <div className="space-y-3">
          {faqs.map((faq, idx) => (
            <div key={idx} className="glass-panel overflow-hidden">
              <button 
                onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
                className="w-full flex items-center justify-between p-4 text-left"
              >
                <span className="font-medium text-white">{faq.question}</span>
                <ChevronDown className={cn(
                  "w-5 h-5 text-zinc-400 transition-transform",
                  openIndex === idx && "rotate-180"
                )} />
              </button>
              {openIndex === idx && (
                <div className="px-4 pb-4 text-zinc-400 text-sm leading-relaxed">
                  {faq.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
